export enum ActionTypes {
  APP_SET_DATA = 'APP_SET_DATA',
  APP_SET_CURRENT_ORG = 'APP_SET_CURRENT_ORG',
}

export type TAppDataAction = {
  type: ActionTypes.APP_SET_DATA
  payload: TAppState
}
export type TAppCurrentOrgAction = {
  type: ActionTypes.APP_SET_CURRENT_ORG
  payload: TAppCurrentOrg
}

export type TAppOrgsState = {
  key: string
  name: string
  brand: string
}

export type TAppCurrentOrg = {
  companies: { id: number; name: string }[]
  settings: TAppOrgsState & {
    colors: Record<string, any>
    // notifications: ...
  }
  token: string
}

export type TAppState = {
  key: string | null
  orgs: TAppOrgsState[]
  currentOrg: TAppCurrentOrg | null
  fetched: boolean
}

export type TActionTypes = TAppDataAction | TAppCurrentOrgAction
